<template>
  <div class="pro-Rec" v-wechat-title="this.title">

    <div></div>
    <div id='id_test_video' class="id_test_vide" style="font-size:0.12rem;">
    
    </div>
    <div class="p-msg"  v-if="havebottom == '2'">
      <div class="topicandNum">
        <p class="topic">{{topic}}</p>
        <p class="num" v-if="isLive=='1'">
           <span>{{show_spectators | peopleNumber }}</span>
           <font v-if="show_spectators.length>=5">w</font>
           人正在看  
        </p>
        <p class="num" v-if="isLive=='0'">
           <span>{{show_spectators | peopleNumber }}</span>
           <font v-if="show_spectators.length>=5">w</font>
           次观看  
        </p>
      </div>
      <div class="pName">
          <span>{{titles}}</span>
         
      </div>

    </div>
    <div class="hostMsg"  v-if="havebottom == '2'">
       <div class="buju">
          <div class="mainMsg">
              <div class="rec-Img">
                  <img :src="hostMSg.avatar" alt=""> 
              </div>
              <div class="rec-Name">
                 <p>{{hostMSg.nickname}}</p>
              </div>
          </div>
          <div class="followHost">
              <p class="follow">{{channelName}}</p>         
          </div>

      </div>


    </div>
    <div class="downloadMsg" v-if="havebottom == '2'">
      <p>
        <img src="../../assets/downNew.png" alt="" >
      </p>
    </div>
    <div class="radioInfo" v-if="havebottom == '1'">
        <img :src="radio_pic" alt="">
        <span>{{radio_name}}</span>
    </div>
    <hotRecommendBold v-if="havebottom == '2'" v-show="recommendRecorded.length>0"></hotRecommendBold>
    <programcommenNew v-if="havebottom == '2'" :commenProgram='recommendRecorded'></programcommenNew>
    <myfooter v-if="havebottom == '2'"></myfooter>
    <div v-if="havebottom == '1'" class="programinfo">
        <p class="programTitle">节目介绍</p>
        <p class="programMassage">{{info}}</p>
    </div>
  </div>
  
</template>

<script>

 
import programcommenNew from '../commen/programcommenNew'
import myfooter from '../commen/myfooter'
import hotRecommendBold from '../commen/hotRecommendBold'
let connection = navigator.connection||navigator.mozConnection||navigator.webkitConnection||{tyep:'unknown'};
let type_text = ['unknown','ethernet','wifi','2g','3g','4g','none'];
import cbct from '../../../static/js/base.js'
import toast from '../commen/toast.vue'
import qs from 'qs'
export default {
  name: 'share',
  props: {
  
  },
  
   data(){
    return {
      programRecordedMsg:[],
      hls_url:[],
      recommendRecorded:[],
      autoplay:false,
      number:'',
      type:'',
      isLive:'',
      live:'',
      isRecorded:'的回放',
      title:"",
      appName:'-听见广播',
      millions:'',
      peopleNumbers:'',
      havebottom:'',
      info:'',
      radio_name:'',
      radio_pic:'',
      // 改动参数
      topic:'',
      titles:'',
      show_spectators:'0',
      hostImg:'',
      hostMSg:[],
      channelName:'',



    }
  },
  filters:{
     peopleNumber:function(n1){
         if (n1!="") {
            let strNum="";
         if (n1.length>=5) {
           strNum=(parseFloat(n1/10000).toFixed(1))
         }else{
           strNum=n1
         }
         return strNum     
         }
     }
  },
 
  methods:{
      get_status(){//判断网络状况
        if(typeof(connection.type) == "number"){
          connection.type_text = type_text[connection.type];
        }else{
          connection.type_text = connection.type;
        }
        if(typeof(connection.bandwidth) == "number"){
          if(connection.bandwidth > 10){
            connection.type = 'wifi';
          }else if(connection.bandwidth > 2){
            connection.type = '3g';
          }else if(connection.bandwidth > 0){
            connection.type = '2g';
          }else if(connection.bandwidth == 0){
            connection.type = 'none';
          }else{
            connection.type = 'unknown';
          }
        }
        if (connection.type_text) {
          return connection.type_text
        }else if(connection.type){
          return connection.type
        }

      
      },
      isPlay(){
        let self=this;
            self.$api.post(cbct.baseurl+"share/play",qs.stringify({
              'play_id':this.number,
              'type':this.type,
            })).then(function(res){
            if(res.c==cbct.code.successCode) {
                 if(res.d.info.is_del=='1'){
                    // console.log(res.d.info.is_del)
                     self.$router.push({
                        path:'delPage'
                    })
                    return;
                  }
              self.peopleNumbers = res.d.live.show_spectators;  
              self.hls_url=res.d.live.hls_url;
              if(self.$route.query.title){
                self.title=self.$route.query.title;
              }else{
                self.title=res.d.live.title+self.isRecorded+self.appName;
              }
              self.info = res.d.info.introduction;
              self.radio_name = res.d.info.title;
              self.radio_pic = res.d.info.avatar;

              if(res.d.recommend.length>0) {
                self.recommendRecorded=res.d.recommend;
              }else if(res.d.recommend.length==0){
                self.recommendRecorded=['none'];
              }
              self.live=res.d.live; //检测是否为空
              var option = {
                "m3u8": self.hls_url,
                autoplay:self.autoplay,
                live:false,
                "width" : '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                h5_flv:true,
                flash:true,
                wording: {
                2032: '请求视频失败，请检查网络',
                2048: '请求m3u8文件失败，可能是网络错误或者跨域问题'
                },
                listener: function (msg) {
                }
              }
              window.tcplayer = new TcPlayer('id_test_video', option);
              if (self.get_status()=='wifi') {//wifi下面自动播放
                window.tcplayer.play();
            }
            }else{
                self.bus.$emit('toast',{show:true,title:res.m})
            }     
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isAndroid) {
                // console.log($('.vcp-fullscreen-toggle'))
                $('.vcp-fullscreen-toggle').css('display','block');
            }
            if (isIOS) {
                // console.log($('.vcp-fullscreen-toggle'))
                $('.vcp-fullscreen-toggle').css('display','none');
            }  
          }).catch((res)=>{
                // this.bus.$emit('toast',{show:true,title:'服务器错误'})

        });



      },
      isLives(){
        let self=this;
           self.$api.post(cbct.baseurl+"share/live",qs.stringify({
             'number':this.number,
              'type':this.type,
            })).then(function(res){
      
              if (res.c==cbct.code.successCode) {
                if(res.d.info.is_del == '1'){
                    self.$router.push({
                      path:'delPage'
                    })
                }
                self.live=res.d.live; //检测是否为空
                if (self.live.length == '0') {
                  // console.log("1");
                  self.$router.push({
                    path:'programStop?isendShare=1&programme_id='+self.number+'&type='+self.type
                  })
                }
                self.programRecordedMsg=res.d.live;
                self.peopleNumbers = res.d.live.show_spectators;
                self.hls_url=res.d.live.hls_url;
                self.hostMSg=res.d.live.hosts[0];
                self.info = res.d.info.introduction;
                self.radio_name = res.d.info.title;
                self.radio_pic = res.d.info.avatar;
                self.channelName=res.d.info.channel_name;
                if(self.$route.query.title){
                  self.title=self.$route.query.title;
                }else{
                  self.title=res.d.live.title+self.appName;
                }
                self.topic = res.d.live.topic;
                self.titles = res.d.live.title;
                self.show_spectators = res.d.live.show_spectators;
              if (res.d.recommend.length!=0) {
                self.recommendRecorded=res.d.recommend;
              }else if(res.d.recommend.length==0){
                self.recommendRecorded=['none'];
              }
           
              var option = {
                "m3u8": self.hls_url,
                autoplay:self.autoplay,
                live:true,
                "width" : '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                h5_flv:true,
                flash:true,
                wording: {
                2032: '请求视频失败，请检查网络',
                2048: '请求m3u8文件失败，可能是网络错误或者跨域问题'
                },
                listener: function (msg) {
                }
              }
             window.tcplayer = new TcPlayer('id_test_video', option);
            if (self.get_status()=='wifi') {//wifi下面自动播放
              window.tcplayer.play();
            }

            }else{
                self.bus.$emit('toast',{show:true,title:res.m})
            }
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isAndroid) {
                // console.log($('.vcp-fullscreen-toggle'))
                $('.vcp-fullscreen-toggle').css('display','block');
            }
            if (isIOS) {
                // console.log($('.vcp-fullscreen-toggle'))
                $('.vcp-fullscreen-toggle').css('display','none');
            }
              
          }).catch((res)=>{
          //  console.log('节目直播res',res);
          
          });;

      },
  
  },
  created(){
      if(this.$route.query.havebottom){
          this.havebottom=this.$route.query.havebottom;
      }else{
          this.havebottom = '2';
      }
      let self=this;     
      if(self.$route.query.number){
        self.number=self.$route.query.number;
      }
      if(self.$route.query.live_id){
        self.number=self.$route.query.live_id;
      }
      self.type=self.$route.query.type;
      self.isLive=self.$route.query.isLive;
      if (self.isLive=='0') {
        this.isPlay();
      }else if(self.isLive=='1'){
        this.isLives();
      }
 
  },
  components: {
      programcommenNew,
      myfooter,
      hotRecommendBold
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
  margin: 0;
  padding: 0;
}
.pro-Rec{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  /* border: solid 1px red; */
} 
.downloadMsg{

box-sizing: border-box;
border-bottom: solid 2px rgba(221,221,221,0.6);
}
.downloadMsg p{
  height: 0.76rem;
  width: 4.4rem;
  margin:0.35rem auto 0.34rem;

}
.downloadMsg p img{
  width: 100%;
  height: 100%;
}
.p-msg{
  box-sizing: border-box;
  padding: 0.17rem 0.32rem 0.16rem; 
  font-size: 0.24rem;
}
.topicandNum{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.topic{
  font-weight: bold;
  font-size: 0.3rem;
  color:rgb(49, 49, 49,1);
  height: 0.42rem;
  line-height: 0.42rem; 
}
.num{
  font-size: 0.24rem;
  color: rgba(91,91,91,1);
  font-weight: 500;
}
.pName{
  text-align: left;
  height: 0.37rem;
  line-height: 0.37rem;
  font-size: 0.26rem;
  color: rgba(102,102,102,1);
}

.rec-Msg{
  padding: 0.26rem 0.23rem 0.24rem; 
  /* border: solid 1px; */
}
.buju{
  height: 1.2rem;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background:rgba(255,255,255,1);
  font-weight:400;
  padding: 0 0.32rem;
  justify-content: space-between;
  border-top: solid 2px rgba(221,221,221,0.6);
  border-bottom: solid 2px rgba(221,221,221,0.6);
}
.mainMsg{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rec-Img{
  width: 0.64rem;
  height: 0.64rem;
  /* border: solid 1px; */
  
}
.rec-Img>img{
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 100%;
}
.rec-Name{
  margin-left: .26rem;
  font-size: .3rem;
  color: rgba(49,49,49,1);
  font-weight: 500;
}
.followHost{
  font-size:0.24rem;
  color:rgba(91,91,91,1);
  font-weight: 500;

 
}
.radioInfo{
  width: 100%;
  height: 1.3rem;
  display: flex;
  justify-content: start;
  overflow: hidden;
  margin-top: 0.1rem;
  border-bottom: 1px solid #ddd;
}
.radioInfo img{
  width: 0.8rem;
  height: 0.8rem;
  border-radius: 50%;
  margin-top: 0.25rem;
  margin-left: 0.42rem;
}
.radioInfo span{
  font-size: 0.3rem;
  color: #333;
  line-height: 1.3rem;
  margin-left: 0.1rem;
  max-width: 5.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.programinfo{
  margin-top: 5px;
  font-size: 0.26rem;
  color: #666666;
}
.programTitle{
  text-align: left;
  padding-left: 0.32rem;
  line-height: 0.8rem;
  font-size: 0.28rem;
  color: #333;
  font-weight: bold;
}
.programMassage{
  padding: 0 0.32rem;
  text-align: left;
  line-height: 0.35rem;
}
</style>
